// extracted by mini-css-extract-plugin
module.exports = {"Container":"ResultPayment_Container__sF7LF","WrapperButton":"ResultPayment_WrapperButton__OgKBa"};